<template>
  <a-button :type="id ? 'link' : 'primary'" @click="onhandleShow">{{
    text
  }}</a-button>
  <a-modal :open="visible" class="auth" :title="text" @cancel="handleCancel">
    <div class="content">
      <!-- {{ props.systems }} -->
      <a-form name="custom-validation" ref="formRef" :model="formState">
        <a-form-item
          :wrapper-col="{ span: 8 }"
          label="选择系统："
          name="systems"
        >
          <a-select
            v-model:value="formState.systems"
            allowClear
            showSearch
            :filterOption="filterOption"
            placeholder="请选择"
            style="width: 100%"
          >
            <a-select-option
              :value="item.id"
              :name="item.name"
              v-for="(item, key) in props.systems.menuSystem"
              :key="key"
            >
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <template v-if="options.length > 0">
          <a-checkbox
            v-model:checked="checkAll"
            :indeterminate="indeterminate"
            @change="onCheckAllChange"
          >
            全选
          </a-checkbox>
          <a-checkbox-group v-model:value="checkedList">
            <template v-for="item in options" :key="item.id">
              <a-checkbox :value="item.id">{{ item.name }}</a-checkbox>
            </template>
          </a-checkbox-group>
        </template>
      </a-form>
    </div>
    <template #footer>
      <div class="tac">
        <a-button @click="handleCancel">取消</a-button>
        <a-button type="primary" :loading="loading" @click="handleOk"
          >新增</a-button
        >
      </div>
    </template>
  </a-modal>
</template>

<script>
import { reactive, inject, toRefs, watch, ref, computed } from 'vue'
import { user_create_role_post } from 'server/modules/351.js'
import { message } from 'ant-design-vue'

export default {
  props: ['systems'],
  setup(props, context) {
    const state1 = inject('state')
    const { attrs } = context
    const assignState = reactive({
      visible: false,
      loading: false,
      ...attrs,
      systems: computed(() => state1.basicInfo.menuSystem),
      onhandleShow() {
        if (state1.selectedRowKeys.length === 0 && !attrs.id) {
          return message.warning('请先勾选用户！')
        }
        formState.systems = undefined
        options.value = []
        state.checkAll = false
        state.checkedList.length = 0
        assignState.visible = true
      },
      handleOk: () => {
        assignState.loading = true
        user_create_role_post({
          userIds: attrs.id ? [attrs.id] : state1.selectedRowKeys,
          roleIds: state.checkedList
        })
          .then(res => {
            if (res.success) {
              message.success(res.data)
              assignState.visible = false
            } else {
              message.error(res.retInfo)
            }
            assignState.loading = false
          })
          .catch(() => {
            assignState.loading = false
          })
      },
      filterOption: (input, option) => {
        return option.name.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
    })
    const onCheckAllChange = e => {
      Object.assign(state, {
        checkedList: e.target.checked ? options.value.map(v => v.id) : [],
        indeterminate: false
      })
    }
    const handleCancel = () => {
      assignState.visible = false
    }
    const formState = reactive({
      systems: undefined
    })

    const state = reactive({
      indeterminate: false,
      plainOptions: [],
      checkAll: false,
      checkedList: []
    })

    const options = ref([])

    function unique(uniqueArr) {
      let has = {}
      return uniqueArr.reduce(function(arr, item) {
        !has[item.name] && (has[item.name] = true && arr.push(item))
        return arr
      }, [])
    }

    watch(
      () => formState.systems,
      v => {
        options.value = []
        state.plainOptions.map(t => {
          if (t.menuSystemId === v) {
            options.value.push(t)
          }
        })
        options.value = unique(options.value)
      }
    )

    watch(
      () => formState.systems,
      v => {
        console.log(v)
        state.checkAll = false
        state.indeterminate = false
        state.checkedList.length = 0
      }
    )

    watch(
      () => state.checkedList,
      val => {
        state.indeterminate = !!val.length && val.length < options.value.length
        state.checkAll = val.length === options.value.length
      }
    )

    watch(
      () => props.systems,
      v => {
        // console.log('watch', v)
        state.plainOptions = v.role
        // assignState.systems = v.menuSystem
      },
      {
        deep: true,
        immediate: true
      }
    )

    return {
      ...toRefs(assignState),
      state1,
      handleCancel,
      formState,
      onCheckAllChange,
      ...toRefs(state),
      options,
      props
    }
  }
}
</script>
<style lang="scss" scoped>
.auth :deep(.portal-ant-modal-footer) {
  border-top-width: 0;
}
</style>
